import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BehaviorSubject, Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import { B2BNetworkcardComponent } from '../../../components/cards/b2bnetwork-card/b2bnetwork-card.component';
import { FilterPipe } from '../../../pipe/SearchFilter/filter.pipe';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { WidgetModule } from '../../../widget/widget.module';
import { NodataFoundComponent } from '../../../widget/nodata-found/nodata-found.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';




@Component({
  selector: 'app-membernetwork-connection',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, FormsModule, InfiniteScrollModule,
CommonSkeletonComponent, B2BNetworkcardComponent, NodataFoundComponent, WidgetModule, FilterPipe,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './membernetwork-connection.component.html',
  styleUrls: ['./membernetwork-connection.component.scss']
})

export class MembernetworkConnectionComponent implements OnInit {
  searchKey
  userType: any = localStorage.getItem('userType');
  uesrId=localStorage.getItem('userId');
  page: string = 'landingpage';
  stopScroll:boolean=false
  statusList = null;
  count: number = 0;
  noDatafound: Array<string>;
  showNoDatafound: boolean = false;

  searchSubject = new Subject<string>();
  connectionlistuserdata: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  searchContent:string="";
  params = {
    userId: this.uesrId,
    page: 0,
    limit: 10,
    searchAfterKey: null,
    statusList:this.statusList,
    searchContent: "",

  };
  btnnameshow: any;
  connect: boolean = false;
  allConnect: boolean = true;
  requestsent: boolean = false;
  prevAfterkey : Array<any> = [];
  requestrecived: boolean = false;
  memberNetworklist: any = [];


  loadAPIcall:boolean=false;
  businessDetails: any;


  constructor(
    private util: UtilService,
    private api: ApiService,
    private searchData : SearchData) { }

  ngOnInit() {
      window.scrollTo(0, 0);
      this.getBusinessId();
      this.memberinNetworklist(this.statusList,null);
      this.searchSubject.pipe(
        debounceTime(1500),
        distinctUntilChanged()
      )
        .subscribe(
          res => {
            this.updateSearch();
          }
        )

  }

  getBusinessId(){
    const userId = localStorage.getItem('userId');
    this.api.query(`business/findUserRoleInBusiness/${userId}`).subscribe(response => {
      this.businessDetails = {
        ...this.businessDetails, // Keep existing details
        id: response.data.businessData.businessId,
        businessEmail: response.data.businessData.businessEmail,
        businessName: response.data.businessData.businessName,
        bid: response.data.businessData.platformBusinesId,
        plan: response.data.businessData.subscriptionType
      };
    });
  }

  updateSearch() {
    this.params.searchContent = this.searchContent.trim() !== "" ? this.searchContent.trim() : null;
    this.params.searchAfterKey = null;
    this.count = 0;
    this.stopScroll = false;
    this.connectionlistuserdata.next([]); // Clearing old data
    this.memberinNetworklist(this.statusList,null); // Fetching new data
  }

  filterstatus(filter, status?: string){
    this.params.searchAfterKey=null;
    this.params.searchContent="";
    this.searchContent = ''; // Clear the searchContent value
    this.count=0
    this.stopScroll=false
    this.connectionlistuserdata.next([]);
    this.memberinNetworklist(filter,null);
  }
  keyupdata(value : string) {
    this.searchSubject.next(value);
}
  onScrollDown() {
    if (this.prevAfterkey !== undefined && JSON.stringify(this.params.searchAfterKey) !== JSON.stringify(this.prevAfterkey)) {
      this.params.searchAfterKey = (this.prevAfterkey && this.prevAfterkey.length === 0) ? null : this.prevAfterkey;
      this.memberinNetworklist(this.statusList, null);
    }
  }
  memberinNetworklist(filter, action) {
    this.loadAPIcall = true;
    let noData: Array<string> = [];
    this.params.statusList = filter==null?filter:[filter];
    this.statusList = filter;
    if (this.statusList === 'CONNECTED') {
        noData = this.searchContent !== "" ? ['No data available!'] : ['No active contacts'];
        this.btnnameshow = 'Active Contacts';
        this.connect = true;
        this.requestsent = false;
        this.requestrecived = false;
        this.allConnect = false;
    } else if (this.statusList === 'PENDING') {
        noData = this.searchContent !== "" ? ['No data available!'] : ['No contacts requests received'];
        this.btnnameshow = 'Requests Received';
        this.connect = false;
        this.requestsent = false;
        this.requestrecived = true;
        this.allConnect = false;
    } else if (this.statusList === 'REQUEST_SENT') {
        noData = this.searchContent !== "" ? ['No data available!'] : ['No contacts request sent'];
        this.btnnameshow = 'Requests Sent';
        this.allConnect = false;
        this.connect = false;
        this.requestsent = true;
        this.requestrecived = false;
    } else if (this.statusList === null && action !== 'remove') {
        noData = ['You have not received any member contacts yet.'];
        this.btnnameshow = 'All';
        this.allConnect = true;
        this.connect = false;
        this.requestsent = false;
        this.requestrecived = false;
    } else if (this.searchContent !== "") {
        noData = ['No data available!'];
    }

    this.util.startLoader();
    this.api.create('business/findBusinessContactsOfUser', this.params).subscribe(res => {
        this.loadAPIcall = false;
        this.util.stopLoader();
        let data = res.data.businessContactList;
        if (data != null) {
            const resData = data;
            const afterKey = res.data && res.data.searchAfterKey;
            if (resData) {
                if (JSON.stringify(this.prevAfterkey) === JSON.stringify(afterKey) || resData.length === 0) {
                    this.stopScroll = true;
                }
                this.prevAfterkey = afterKey;


                const existingData = this.connectionlistuserdata.getValue();
                const uniqueEntries = new Set(existingData.map(item => JSON.stringify(item)));

                resData.forEach(newItem => {
                    const stringifiedNewItem = JSON.stringify(newItem);
                    uniqueEntries.add(stringifiedNewItem);
                });


                const combined = Array.from(uniqueEntries).map(item => JSON.parse(item));
                this.connectionlistuserdata.next(combined);


                if (res.data.totalBusinessContactsCount !== undefined) {
                    this.count = res.data.totalBusinessContactsCount;
                }


                this.showNoDatafound = this.connectionlistuserdata.getValue().length === 0;
                this.noDatafound = this.showNoDatafound ? noData : [];
            }
        }
    }, error => {
        this.util.stopLoader();
        this.showNoDatafound = true;
        this.noDatafound = ['An error occurred. Please try again later.'];
    });
}

  refreshmemberNetworklist(eventData: { value: any, action: string }) {
    const { value, action } = eventData;
    this.stopScroll=false
    this.params.searchAfterKey = null;
    this.prevAfterkey = null;
    this.connectionlistuserdata.next([]);
    this.memberinNetworklist(this.statusList, action);

  }

}

